AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "TrialCollection");

AoPS.Alcumus.Models.TrialCollection = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcMBase = AoPS.Alcumus.Models.Base;

	return AlcMBase.BaseCollection.extend({
		// Amount of trials to load in each server call. Currently fixed with
		// no way to change on a per-call basis.
		AMOUNT_PER_LOAD: 20,

		// Comparator for all trial collections.
		comparator: function (trial) {
			return -trial.get("final_trial_id");
		},

		// Set the parameters to use when loading trials. This defines what kinds
		// of trials this collection holds. Call this as soon as you construct
		// a trial collection.
		setLoadParams: function (load_params) {
			this.load_params = load_params;
		},

		// Monitor a user model for new trials and add any applicable ones.
		watchUser: function (user) {
			this.listenTo(user, "new_trial", function (trial) {
				if (this.isTrialApplicable(trial)) {
					this.addToFront(trial);
				}
			});
		},

		// Get the total
		getTotal: function () {
			return this.total;
		},

		// Ask the model to load more trials at the end of the list, if there
		// are any. Amount loaded per server request is a fixed constant.
		requestLoadMore: function (callback, context) {
			// Have we loaded every trial there is?
			if (this.all_loaded) {
				// Yep; fire immediately
				callback = LoadUtils.makeCallback(callback, context);
				setTimeout(function () {
					callback(true, {all_loaded: true, trial_ids: []});
				}, 0);
				return;
				// Is a load running now?
			} else if (!this.more_loader) {
				// Nope; start one.
				// In the load_trials_before AJAX API, setting before_id to -1 means
				// start from beginning
				this.more_loader = new LoadUtils.LoadManager({
					loadHandler: _.partial(
						this.loadBefore,
						this.before_id || -1,
						this.AMOUNT_PER_LOAD
					),
					context: this,
				});
			}
			// Either get the loader moving, or piggyback the callback on the existing.
			this.more_loader.requestLoad(callback, context);
		},

		// Ask the model to ensure that all trials loaded at the beginning of the
		// list are loaded. Callback fires immediately if collection has more trials
		// than the amount loaded in each server request.
		requestLoadStart: function (callback, context) {
			if (this.length < this.AMOUNT_PER_LOAD) {
				return this.requestLoadMore(callback, context);
			} else {
				// We have enough, so fire immediately.
				callback = LoadUtils.makeCallback(callback, context);
				setTimeout(function () {
					callback(true, {});
				}, 0);
			}
		},

		// Helper for user monitoring methods.
		addToFront: function (trial) {
			this.add(trial, {at: 0});
			this.total = this.total ? this.total + 1 : 1;
			this.trigger("new_trial");
		},

		// Determine whether a trial should be added to this collection. Requires
		// setLoadParams to be called first.
		isTrialApplicable: function (trial) {
			var params = this.load_params;
			if (!params) {
				return false;
			}

			// Easy cases
			if (params.user_id !== trial.get("user").id) {
				return false;
			} else if (!params.subject_id && !params.class_id && !params.topic_id) {
				// user_id was the only check needed
				return true;
			}

			// We determine applicability by checking all of the trial's topics for
			// a match with the given subject/class/topic.
			return trial.get("topics").any(function (topic) {
				if (params.subject_id) {
					return params.subject_id === topic.get("subject").id;
				} else if (params.class_id) {
					return _.contains(topic.get("classes").pluck("id"), params.class_id);
				} else if (params.topic_id) {
					return params.topic_id === topic.id;
				}
				return false;
			});
		},

		// Internal method used as loadHandler for loader objects.
		loadBefore: function (before_id, count, callback) {
			var ajax_params = _.extend(
				{
					before_id: before_id,
					count: count,
				},
				this.load_params
			);

			AlcMBase.ajax.run(
				"load_trials_before",
				ajax_params,
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}

					this.unpackAll(data.response.trials, "trial_id");
					this.total = parseInt(data.response.trial_total, 10);
					delete this.more_loader;

					var trial_ids = _.map(data.response.trials, function (trial) {
						return parseInt(trial.final_trial_id, 10);
					});
					this.before_id = _.min(trial_ids);

					this.all_loaded =
						this.total <= this.length || !data.response.trials.length;

					this.trigger("trials_loaded");
					callback(true, {
						all_loaded: this.all_loaded,
						trial_ids: trial_ids,
					});
				}, this)
			);
		},
	});
})();
